import React, { Component, Children } from "react";
import {bindActionCreators} from 'redux'
import Joyride from 'react-joyride';
import { connect } from 'react-redux'
import PropTypes from "prop-types";
import { nextJoyride } from '../../modules/joyride'

class joyrideProvider extends Component {
  // la méthode getChildContext est appelée pour fournir le `context`
  // dans notre cas, on le récupère des `props`

  static childContextTypes = {
    joyrideProvider: PropTypes.object
  };

  getChildContext() {
    return {
      joyrideProvider: this
    };
  }

  // on render l'enfant
  render() {
    const { children } = this.props;
    return <div>
      <Joyride
        ref={c => (this.joyride = c)}
        type="continuous"
        disableOverlay={true}
        callback={(data) => {
          /*if (data.type ===  'hole:click') {
            document.querySelector(data.step.selector).click();
            setTimeout(() => {
          this.joyride.next();
          }, 500);
          }*/
          if (data.type === 'step:after') {
            this.props.nextJoyride();
            console.log(data);
          }
        }}
        autoStart={true}
        // stepIndex={this.props.joyride.step}
        allowClicksThruHole={true}
        steps={[{
          title: 'First Step',
          text: 'Start using the <strong>joyride</strong>',
          selector: '.first-step',
          type: 'click',
          style: {
            beacon: {
              offsetY: -24
            },
            footer: {
              display: 'none'
            }
          }
        },{
          title: 'Second Step',
          text: 'Start using the <strong>joyride</strong>',
          selector: '.second-step'
        },{
          title: 'Third Step',
          text: 'Start using the <strong>joyride</strong>',
          selector: '.third-step'
        }]}
        run={this.props.joyride.run} // or some other boolean for when you want to start it
        stepIndex={this.props.joyride.stepIndex}
        debug={true}
      />
      {children ? React.Children.only(this.props.children) : null}
    </div>
  }
}

function mapStateToProps(state) {

  const { joyride } = state

  return {
    joyride
  }
}


const mapDispatchToProps = dispatch => bindActionCreators({
  nextJoyride
}, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(joyrideProvider)



// WEBPACK FOOTER //
// ./src/containers/app/joyrideProvider.js